const BackgroundStars: React.FC = () => {
  return (
    <>
      <div id="stars" data-testid="stars"></div>
      <div id="stars2" data-testid="stars2"></div>
      <div id="stars3" data-testid="stars3"></div>
    </>
  );
};

export default BackgroundStars;
